import React, { memo, forwardRef } from "react"
import { StyledEditorWrapper } from "@/components/classroom/Resources/StyledComponents"
import Editor, { editorStateToHtml } from "./Editor"

const FormEditor = memo(
  forwardRef(({ value, onChange, wrapperClassName = "", editorClassName = "", dataTest }, ref) => {
    const handleEditorChange = editorState => {
      onChange(editorStateToHtml(editorState))
    }

    return (
      <StyledEditorWrapper className={wrapperClassName} data-testid={dataTest}>
        <Editor ref={ref} initialContentState={value} onChange={handleEditorChange} editorClassName={editorClassName} />
      </StyledEditorWrapper>
    )
  })
)

FormEditor.displayName = "FormEditor"

export default FormEditor
